import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { DynamicValueInput } from './LoanActionItems';

const LoanActionExportLoanPackageRow = ({ index, rootPath, isDisabled, isEditAllowed }) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <div>
      <DynamicValueInput
        disabled={isDisabled || !isEditAllowed}
        label="Include documents"
        name={`${fieldPath}.includeDocuments`}
        type={FieldTypesEnum.BOOLEAN}
      />
      <DynamicValueInput
        disabled={isDisabled || !isEditAllowed}
        label="Include MISMO 3.4 file"
        name={`${fieldPath}.includeMismo`}
        type={FieldTypesEnum.BOOLEAN}
      />
    </div>
  );
};

LoanActionExportLoanPackageRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
};

export default memo(LoanActionExportLoanPackageRow);
